import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  SchemasState,
  Schema,
  SchemasListData,
} from '../../types/schemas.types';

const initialState: SchemasState = {
  schemas: [],
  selectedSchema: null,
  loading: false,
  error: null,
  pagination: {
    page: 1,
    pageSize: 10,
    totalPages: 0,
    totalRecords: 0,
    hasMorePages: false,
  },
  search: '',
};

const schemasSlice = createSlice({
  name: 'schemas',
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
    },
    setSchemas: (state, action: PayloadAction<SchemasListData>) => {
      state.schemas = action.payload.schemas;
      state.pagination = {
        ...state.pagination,
        totalPages: action.payload.totalPages,
        totalRecords: action.payload.totalRecords,
        hasMorePages: action.payload.hasMorePages,
      };
      state.loading = false;
      state.error = null;
    },
    setSelectedSchema: (state, action: PayloadAction<Schema | null>) => {
      state.selectedSchema = action.payload;
    },
    setPage: (state, action: PayloadAction<number>) => {
      state.pagination.page = action.payload;
    },
    setPageSize: (state, action: PayloadAction<number>) => {
      state.pagination.pageSize = action.payload;
    },
    setSearch: (state, action: PayloadAction<string>) => {
      state.search = action.payload;
      state.pagination.page = 1;
    },
    clearError: (state) => {
      state.error = null;
    },
    clearSelectedSchema: (state) => {
      state.selectedSchema = null;
    },
    addSchema: (state, action: PayloadAction<Schema>) => {
      state.schemas.unshift(action.payload);
      state.pagination.totalRecords += 1;
    },
    updateSchema: (state, action: PayloadAction<Schema>) => {
      const index = state.schemas.findIndex((schema) => schema.id === action.payload.id);
      if (index !== -1) {
        state.schemas[index] = action.payload;
      }
      if (state.selectedSchema?.id === action.payload.id) {
        state.selectedSchema = action.payload;
      }
    },
    deleteSchema: (state, action: PayloadAction<string>) => {
      state.schemas = state.schemas.filter((schema) => schema.id !== action.payload);
      state.pagination.totalRecords -= 1;
      if (state.selectedSchema?.id === action.payload) {
        state.selectedSchema = null;
      }
    },
  },
});

export const {
  setLoading,
  setError,
  setSchemas,
  setSelectedSchema,
  setPage,
  setPageSize,
  setSearch,
  clearError,
  clearSelectedSchema,
  addSchema,
  updateSchema,
  deleteSchema,
} = schemasSlice.actions;

export default schemasSlice.reducer;
